<template>
  <div>
    <el-card
      class="absolute area-clip w-468px z-99 text-white p-10px"
      :style="{
        height: location.height,
        top: location.top,
        right: location.float === 'right' ? '25px' : '',
        left: location.float === 'left' ? '25px' : '',
      }"
    >
      <!-- 头部 -->
      <div slot="header" class="flex justify-between items-center">
        <span class="text-14px">区域剖切管理</span>
        <div class="flex items-center">
          <el-tooltip content="导出" :open-delay="1000" effect="light">
            <el-button
              type="success"
              class="iconfont icon-line-download !w-25px !h-25px !p-0px !leading-25px"
              @click="exportClip"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="导入" :open-delay="1000" effect="light">
            <el-button
              type="success"
              class="iconfont icon-line-upload !w-25px !h-25px !p-0px !leading-25px"
              @click="uploadClip"
            ></el-button>
          </el-tooltip>
          <el-dropdown class="ml-10px">
            <span class="el-dropdown-link">
              <i class="iconfont icon-line-moreHorizontal text-14px font-bold"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="operateTree(true)">展开全部</el-dropdown-item>
              <el-dropdown-item @click.native="operateTree(false)">收起全部</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span
            class="ml-20px iconfont icon-line-close float-right cursor-pointer text-12px"
            @click="closeComponent"
          ></span>
        </div>
      </div>
      <!-- 搜索 -->
      <div class="flex h-38px p-5px mt-5px mb-5px">
        <el-input
          class="flex-1 mr-10px"
          prefix-icon="el-icon-search"
          placeholder="搜索名称"
          v-model="keyWord"
          clearable
          @keyup.enter.native="getTreeData"
        ></el-input>
        <el-button type="primary" size="mini" @click="getTreeData" class="!h-36px">搜索</el-button>
        <el-button size="mini" type="primary" class="!h-36px" @click="handleTreeData('create')"
          >新增</el-button
        >
      </div>
      <!-- 区域剖切树结构 -->
      <div class="p-5px" :class="showParams ? 'h-[calc(100%-305px)]' : 'h-[calc(100%-105px)]'">
        <el-tree
          v-if="treeStandBy"
          v-loading="treeLoading"
          highlight-current
          node-key="id"
          ref="tree"
          :props="{
            children: 'children',
            label: 'name',
          }"
          :data="treeData"
          :expand-on-click-node="false"
          :current-node-key="currentSelectKey"
          :default-expanded-keys="defaultExpandIds"
          :default-expand-all="defaultExpandAll"
          :filter-node-method="filterTreeNode"
          @node-click="handleDocNodeClick"
        >
          <div slot-scope="{ node, data }" class="w-[calc(100%-24px)]">
            <div class="flex items-center text-14px">
              <p :title="node.label" class="flex-1 mr-15px truncate">{{ node.label }}</p>
              <div class="mr-5px">
                <el-dropdown>
                  <span>
                    <i class="iconfont icon-line-moreVertical text-white text-14px font-bold"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="handleTreeData('create', data)"
                      >新增</el-dropdown-item
                    >
                    <el-dropdown-item @click.native="handleTreeData('edit', data)"
                      >编辑</el-dropdown-item
                    >
                    <el-dropdown-item @click.native="removeTreeData(data)">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </el-tree>
      </div>
      <div v-if="showParams">
        <!-- 剖切参数 -->
        <div class="h-190px p-5px border-top-1px border-gray-500">
          <div class="text-14px text-white">剖切参数</div>
          <el-form :model="clipForm" :rules="clipRules" ref="clipFormRef" label-width="90px">
            <el-form-item label="最大坐标" prop="maximumLocation">
              <el-row :gutter="5">
                <el-col :span="8">
                  <el-input
                    v-model="clipForm.maximumLocation.x"
                    @input="updateClipByAabb"
                    clearable
                  />
                </el-col>
                <el-col :span="8">
                  <el-input
                    v-model="clipForm.maximumLocation.y"
                    @input="updateClipByAabb"
                    clearable
                  />
                </el-col>
                <el-col :span="7">
                  <el-input
                    v-model="clipForm.maximumLocation.z"
                    @input="updateClipByAabb"
                    clearable
                  />
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="最小坐标" prop="minimumLocation">
              <el-row :gutter="5">
                <el-col :span="8">
                  <el-input
                    v-model="clipForm.minimumLocation.x"
                    @input="updateClipByAabb"
                    clearable
                  />
                </el-col>
                <el-col :span="8">
                  <el-input
                    v-model="clipForm.minimumLocation.y"
                    @input="updateClipByAabb"
                    clearable
                  />
                </el-col>
                <el-col :span="7">
                  <el-input
                    v-model="clipForm.minimumLocation.z"
                    @input="updateClipByAabb"
                    clearable
                  />
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="剖切方式" prop="clipType">
              <el-radio v-model="clipForm.clipType" :label="0" @input="changeClipType"
                >内剖切</el-radio
              >
              <el-radio v-model="clipForm.clipType" :label="1" @input="changeClipType"
                >外剖切</el-radio
              >
            </el-form-item>
          </el-form>
        </div>
        <!-- 保存按钮 -->
        <div class="h-60px flex justify-evenly items-center">
          <el-button type="primary" size="mini" @click="closeClip" v-if="isClip"
            >取消剖切</el-button
          >
          <el-button type="primary" size="mini" @click="openClip" v-else>启用剖切</el-button>
          <el-button type="primary" size="mini" @click="save">保存</el-button>
          <el-button type="primary" size="mini" @click="cancelEdit">取消</el-button>
        </div>
      </div>
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      :title="(treeOperateType === 'create' ? '新增' : '编辑') + '剖切区域'"
      :visible.sync="treeDialog"
      v-dialogDrag
      @close="closeTreeForm"
      width="25%"
    >
      <el-form :model="treeForm" :rules="treeRules" ref="treeFormRef" label-width="80px">
        <el-form-item label="区域名称" prop="name">
          <el-input v-model="treeForm.name" size="small" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer" class="text-center">
        <el-button type="primary" size="small" @click="saveTreeForm" :loading="saveLoading"
          >保存</el-button
        >
        <el-button size="small" @click="closeTreeForm">取消</el-button>
      </div>
    </el-dialog>
    <wiz-upload-file
      v-dialogDrag
      @refreshList="getTreeData"
      v-if="showUploadExcelDialog"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
  </div>
</template>

<script>
import {
  isNil,
  isEmpty,
  indexOf,
  filter,
  difference,
  get,
  cloneDeep,
  findIndex,
  forIn,
} from 'lodash'
import { ClipApi } from '@wiz-api/scene-management'
import { TempFileApi } from '@wiz-api/file-management'
import FnMixins from '@/assets/js/fnMixins'
import cloudRender from '../../assets/js/model/index'

const clipApi = new ClipApi()
const tempFileApi = new TempFileApi()
export default {
  props: ['location', 'player', 'loadModelStatus'],
  mixins: [FnMixins],
  data() {
    const checkNumber = (rule, value, calback) => {
      const numberReg = /^(-)?(\d+)(\.\d+)?$/
      const checkValue =
        numberReg.test(value.x) &&
        numberReg.test(value.y) &&
        numberReg.test(value.z) &&
        !isEmpty(value.x) &&
        !isEmpty(value.y) &&
        !isEmpty(value.z)
      if (!checkValue) {
        calback(new Error('请输入正确的坐标'))
        return
      }
      calback()
    }
    return {
      // 搜索关键字
      keyWord: '',
      treeStandBy: true,
      defaultExpandAll: false,
      treeLoading: false,
      treeData: [],
      defaultExpandIds: [],
      treeDialog: false,
      treeOperateType: '',
      // 当前选择的树节点
      currentSelectKey: '',
      selectParentId: '',
      treeForm: {
        name: '',
      },
      treeRules: {
        name: { required: true, message: '请输入区域名称', trigger: 'blur' },
      },
      saveLoading: false,
      // 当前做目录操作的节点
      currentTreeData: null,
      // 是否正在剖切
      isClip: false,
      clipForm: {
        maximumLocation: { x: '', y: '', z: '' },
        minimumLocation: { x: '', y: '', z: '' },
        // 剖切方式默认为外剖切
        clipType: 1,
      },
      clipRules: {
        clipType: { required: true, message: '请选择剖切方式', trigger: 'change' },
        maximumLocation: { required: true, validator: checkNumber, trigger: 'blur' },
        minimumLocation: { required: true, validator: checkNumber, trigger: 'blur' },
      },
      showParams: false,
      // 剖切类型
      clipType: {
        box: 0, // 盒子剖切
        singlePanel: 1, // 单面剖切
        doublePanel: 2, // 双面剖切
        ThreePanel: 3, // 三面剖切
      },
      clipDataType: {
        aabb: 0, // 包围盒
        model: 1, // 模型
        node: 2, // node
        item: 3,
        clipData: 4, // 剖切数据
      },
      toolType: [
        {
          icon: 'icon-bg-model',
          label: '面剖切',
          value: 3,
        },
      ],
      // 场景根节点
      rootNode: null,
      showUploadExcelDialog: false,
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      numberReg: /^(-)?(\d+)(\.\d+)?$/,
      isChangeType: false, // 是否改变剖切方式
      // 单位矩阵
      mat: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
      // 防抖处理相关标识
      handletimer: null,
    }
  },
  async created() {
    await this.getTreeData()
    this.rootNode = await this.player.Native.NodeProxy.rootNode()
  },
  mounted() {
    window.addEventListener('Clip', this.getPoints)
  },
  methods: {
    // 获取剖切树结构
    async getTreeData() {
      this.treeLoading = true
      const [err, res] = await clipApi.menuPageQueryList({
        sceneId: this.$route.query?.sceneId,
        keyWord: this.keyWord || '',
        isQueryAsTree: true,
      })
      if (!err && !isNil(res)) {
        this.treeData = res.items
        if (this.treeData.length) {
          this.treeStandBy = false
          if (isEmpty(this.defaultExpandIds)) {
            this.defaultExpandIds = [this.treeData[0].id]
          } else if (!isEmpty(this.selectParentId)) {
            this.defaultExpandIds.push(this.selectParentId)
          }
          this.$nextTick(() => {
            this.treeStandBy = true
          })
        }
      }
      this.treeLoading = false
    },
    // 树节点增删改操作
    handleTreeData(type, data) {
      this.currentTreeData = data
      this.treeForm = this.$options.data().treeForm
      if (type !== 'create') {
        this.treeForm.name = data.name
      }
      this.treeOperateType = type
      this.treeDialog = true
    },
    // 点击树节点
    async handleDocNodeClick(data) {
      // 点击防抖处理
      if (this.handletimer) {
        clearTimeout(this.handletimer)
        this.handletimer = null
      }
      this.handletimer = setTimeout(async () => {
        this.$refs.clipFormRef && this.$refs.clipFormRef.resetFields()
        this.currentSelectKey = data.id
        this.selectParentId = data.parentId
        this.clipForm = this.$options.data().clipForm
        await this.getParams(data.id)
        await this.setClipVisible()
        this.showParams = true
        clearTimeout(this.handletimer)
        this.handletimer = null
      }, 500)
    },
    // 删除树节点数据
    removeTreeData(data) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await clipApi.callDelete(data.id)
          if (!err) {
            this.defaultExpandIds = difference(this.defaultExpandIds, [data.id])
            this.$message.success({
              showClose: true,
              message: '删除成功！',
            })
            if (this.currentSelectKey === data.id) {
              // 如果删除的是正在展示剖切参数的节点，则不展示剖切参数
              this.cancelEdit()
            }
            this.defaultExpandIds = [data.parentId]
            await this.getTreeData()
          }
        })
        .catch(() => {})
    },
    // 导出
    async exportClip() {
      const [err, res] = await clipApi.callExport(this.$route.query.sceneId)

      if (!err && !isNil(res)) {
        this.downLoadBlob({
          name: '区域剖切.xlsx',
          data: res,
        })
        this.$message({
          showClose: true,
          message: '导出成功',
          type: 'success',
        })
      }
    },
    // 导入
    uploadClip() {
      this.showUploadExcelDialog = true
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const [err, res] = await clipApi.getImportStepsTemplate()
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: '区域剖切导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      forIn({ file }, (value, key) => {
        formData.append('file', value)
      })
      const [err, res] = await clipApi.callImport(this.$route.query?.sceneId, {
        file: formData.get('file'),
      })
      if (!err) {
        this.uploadFileProps.active = 2
        this.uploadFileProps.successCount = res.successCount
        this.uploadFileProps.failureCount = res.failureCount
        // 如需兼容老样式，则resultFile字段为空或者不设置皆可
        this.uploadFileProps.resultFile = res.resultFile
      }
      this.uploadFileProps.btnLoading = false
    },
    // 下载导入结果
    async exportResults() {
      const [err, res] = await tempFileApi.download(this.uploadFileProps.resultFile)
      if (!err) {
        this.downLoadBlob({
          name: '区域剖切导入结果.xlsx',
          data: res,
        })
      }
    },
    // 筛选
    filterTreeNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    // 收起或展开
    operateTree(bool) {
      if (!bool) {
        this.defaultExpandIds = []
      }
      this.treeStandBy = false
      this.defaultExpandAll = bool
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    // 关闭树节点操作弹框
    closeTreeForm() {
      this.treeDialog = false
      this.$refs.treeFormRef.resetFields()
    },
    // 保存树节点操作
    saveTreeForm() {
      this.$refs.treeFormRef.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          // 新增
          if (this.treeOperateType === 'create') {
            const [err, res] = await clipApi.addMutlFolders({
              body: {
                names: [this.treeForm.name],
                parentId: isEmpty(this.currentTreeData?.id) ? null : this.currentTreeData.id,
                sceneId: this.$route.query?.sceneId,
              },
            })
            if (!err) {
              this.$message.success({
                showClose: true,
                message: '新增区域成功',
              })
              if (!isEmpty(this.currentTreeData)) {
                this.defaultExpandIds = [this.currentTreeData.id]
              }
              await this.getTreeData()
              this.closeTreeForm()
            }
          } else {
            // 编辑
            const [err, res] = await clipApi.update(this.currentTreeData.id, {
              body: {
                name: this.treeForm.name,
                parentId: this.currentTreeData.parentId,
                id: this.currentTreeData.id,
              },
            })
            if (!err && !isNil(res)) {
              this.$message.success({
                showClose: true,
                message: '编辑区域成功',
              })
              if (!isEmpty(this.currentTreeData)) {
                this.defaultExpandIds = [this.currentTreeData.parentId]
              }
              await this.getTreeData()
              this.closeTreeForm()
            }
          }
          this.saveLoading = false
        }
      })
    },
    // 检验剖切坐标
    checkClipPos(value) {
      const checkValue =
        this.numberReg.test(value.x) &&
        this.numberReg.test(value.y) &&
        this.numberReg.test(value.z) &&
        !isEmpty(value.x) &&
        !isEmpty(value.y) &&
        !isEmpty(value.z)
      return checkValue
    },
    // 展示剖切区域
    async showArea(type) {
      // 两种情况
      // 1.有最大坐标和最小坐标，根据包围盒剖切
      if (type === 'aabb') {
        const min = cloneDeep(this.clipForm.minimumLocation)
        const max = cloneDeep(this.clipForm.maximumLocation)
        const aabb = [
          [min.x, min.y, min.z],
          [max.x, max.y, max.z],
        ]
        // 通过包围盒的方式展示剖切盒子
        await cloudRender.Clip.createCilp(this.player, this.clipDataType.aabb, this.clipType.box, {
          setIsInside: this.clipForm.clipType === 0,
          setPartCilp: false,
          aabb,
        })
        // 移动视角到包围盒
        await this.player.Native.Camera.moveToAabb(
          {
            min: aabb[0],
            max: aabb[1],
          },
          this.mat,
          0,
          1.1,
          1
        )
      } else if (type === 'node') {
        // 2.没有最大坐标最小坐标，则整个场景剖切
        if (!this.rootNode) return
        // 2.1获取当前点选的节点
        const currentNode = await cloudRender.Node.getSelectedItem(this.player)
        if (currentNode.status && !isEmpty(currentNode.data)) {
          // 如果当前有点选模型，则剖切选中模型
          await this.player.Native.Camera.moveToItem(currentNode.data.item, 1)
          await cloudRender.Clip.createCilp(
            this.player,
            this.clipDataType.item,
            this.clipType.box,
            {
              setIsInside: this.clipForm.clipType === 0,
              setPartCilp: false,
              item: currentNode.data.item,
            }
          )
        } else {
          // 2.2如果当前没有点选模型，则整个场景剖切
          const currentAabb = await this.player.Native.NodeProxy.getAabb(this.rootNode)
          this.player.Native.Camera.addMoveToAabb(
            { min: currentAabb[0], max: currentAabb[1] },
            this.mat,
            1,
            1.1,
            1
          )
          await cloudRender.Clip.createCilp(
            this.player,
            this.clipDataType.node,
            this.clipType.box,
            {
              setIsInside: this.clipForm.clipType === 0,
              setPartCilp: false,
              node: this.rootNode,
            }
          )
        }
      }
    },
    // 输入最大坐标最小坐标更新剖切区域
    async updateClipByAabb() {
      if (
        // 如果输入的坐标通过校验并且当前处于剖切状态
        this.checkClipPos(this.clipForm.minimumLocation) &&
        this.checkClipPos(this.clipForm.maximumLocation) &&
        this.isClip
      ) {
        await cloudRender.Clip.updateClipDataByAabb(this.player, [
          [
            +this.clipForm.minimumLocation.x,
            +this.clipForm.minimumLocation.y,
            +this.clipForm.minimumLocation.z,
          ],
          [
            +this.clipForm.maximumLocation.x,
            +this.clipForm.maximumLocation.y,
            +this.clipForm.maximumLocation.z,
          ],
        ])
      }
    },
    // 获取剖切参数
    async getParams(id) {
      const [err, res] = await clipApi.get(id)
      if (!err && !isNil(res)) {
        if (res.isEnable) {
          this.clipForm.clipType = res.clipType
          this.clipForm.maximumLocation = JSON.parse(res.maximumLocation)
          this.clipForm.minimumLocation = JSON.parse(res.minimumLocation)
          // 展示剖切区域
          await this.showArea('aabb')
        } else if (this.isClip) {
          await this.showArea('node')
        } else {
          // 如果当前区域没有设置剖切参数并且不是剖切状态，则退出剖切
          await cloudRender.Clip.cancelClip(this.player)
          // 视角转为全场景
          const currentAabb = await this.player.Native.NodeProxy.getAabb(this.rootNode)
          this.player.Native.Camera.addMoveToAabb(
            { min: currentAabb[0], max: currentAabb[1] },
            this.mat,
            1,
            1.1,
            1
          )
        }
      }
    },
    // 剖切方式改变
    async changeClipType() {
      if (this.isClip) {
        if (this.clipForm.clipType === 0) {
          this.clipForm.clipType = 1
        } else {
          this.clipForm.clipType = 0
        }
        return this.$message.warning({
          showClose: true,
          message: '请先取消当前剖切再次开启剖切',
        })
      }
      this.isChangeType = true
    },
    // 启用剖切
    async openClip() {
      this.isClip = true
      // 如果最大坐标最小坐标都有
      if (
        this.checkClipPos(this.clipForm.minimumLocation) &&
        this.checkClipPos(this.clipForm.maximumLocation)
      ) {
        if (this.isChangeType) {
          // 如果改变过剖切方式，则通过包围盒的方式重新展示剖切盒子
          await this.showArea('aabb')
          this.isChangeType = false
        } else {
          // 如果没有改变过剖切方式，则直接显示剖切轴和面
          await this.setClipVisible()
        }
      } else {
        // 否则通过根节点的方式展示剖切盒子
        await this.showArea('node')
      }
    },
    // 设置面和轴的可见性
    async setClipVisible() {
      await cloudRender.Clip.setVisible(this.player, 'Axis', this.isClip)
      await cloudRender.Clip.setVisible(this.player, 'Panel', this.isClip)
    },
    // 获取坐标
    getPoints(e) {
      const result = e.detail
      if (result && result.status && result.data.type === 'Clip') {
        const pos = result.data.data.Aabb
        this.clipForm.minimumLocation.x = pos[0]?.[0].toFixed(6)
        this.clipForm.minimumLocation.y = pos[0]?.[1].toFixed(6)
        this.clipForm.minimumLocation.z = pos[0]?.[2].toFixed(6)
        this.clipForm.maximumLocation.x = pos[1]?.[0].toFixed(6)
        this.clipForm.maximumLocation.y = pos[1]?.[1].toFixed(6)
        this.clipForm.maximumLocation.z = pos[1]?.[2].toFixed(6)
      }
    },
    // 关闭剖切
    async closeClip() {
      this.isClip = false
      if (
        this.checkClipPos(this.clipForm.minimumLocation) &&
        this.checkClipPos(this.clipForm.maximumLocation)
      ) {
        this.setClipVisible()
      } else {
        // 取消剖切效果
        await cloudRender.Clip.cancelClip(this.player)
      }
    },
    // 保存剖切结果
    save() {
      this.$refs.clipFormRef.validate(async (valid) => {
        if (valid) {
          const [err, res] = await clipApi.setClipParam({
            body: {
              id: this.currentSelectKey,
              isEnable: true,
              clipType: this.clipForm.clipType,
              maximumLocation: JSON.stringify(this.clipForm.maximumLocation),
              minimumLocation: JSON.stringify(this.clipForm.minimumLocation),
            },
          })
          if (!err) {
            this.$message.success({
              showClose: true,
              message: '保存成功！',
            })
          }
        }
      })
    },
    // 取消编辑剖切参数
    async cancelEdit() {
      this.showParams = false
      // 关闭剖切
      await this.closeClip()
    },
    // 关闭弹窗
    closeComponent() {
      this.$emit('closeComponent', 'AreaClip')
    },
  },
  beforeDestroy() {
    if (this.handletimer) {
      clearTimeout(this.handletimer)
      this.handletimer = null
    }
    cloudRender.Clip.cancelClip(this.player)
    window.removeEventListener('Clip', this.getPoints)
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/index';

.area-clip {
  background-color: rgba(0, 18, 55, 0.3) !important;
  border: none !important;
}

::v-deep .el-col {
  .el-input__inner {
    padding-right: 27px;
  }
}

::v-deep .el-card {
  &__header {
    background: transparent !important;
  }

  &__body {
    padding: 0 !important;
    height: calc(100% - 30px);
    background-color: rgba(24, 41, 72, 0.5) !important;
    border-radius: 2px;
  }

  .el-input--prefix {
    .el-input__inner {
      padding-left: 30px;
    }
  }
}

::v-deep .el-loading-mask {
  background-color: rgba(24, 41, 72, 0.8) !important;
}
</style>
